'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = require('./MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/MenuItem/index.js
 ** module id = 283
 ** module chunks = 0
 **/